var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.items),function(item,idx){return _c('div',{key:idx,staticClass:"tab",class:_vm.current == idx ? 'active' : '',on:{"click":function($event){return _vm.onClickItem(idx)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }